import traplinked_statuses from "../../data/traplinked_statuses.json";

import styles from "./list.module.css";

type ListDataItem = {
  id: string;
  name: string;
  objectName?: string | null;
  address?: string | null;
  digitalMonitorStatus?: number;
  digitalMonitorStatusText?: string;
};

type ListProps = {
  title?: string | null;
  subtitle?: string | null;
  data: ListDataItem[] | [];
  onItemSelected?: any;
  hideShadow?: boolean;
  boldName?: boolean;
};

export const List = ({
  title,
  subtitle,
  data,
  onItemSelected,
  hideShadow = false,
  boldName = false,
}: ListProps) => {
  return (
    <div className={`${styles.list} ${hideShadow ? styles["no-shadow"] : ""}`}>
      {title && <h1 className={styles["list__title"]}>{title}</h1>}
      {subtitle && <h3 className={styles["list__subtitle"]}>{subtitle}</h3>}

      <ul>
        {data?.map((item: ListDataItem, i) => {
          const monitorStatus = traplinked_statuses.find(
            (status) => status.status === item.digitalMonitorStatus
          );

          return (
            <div
              className={styles["list__card"]}
              key={i}
              onClick={() => onItemSelected?.(item)}
            >
              <div className={styles["list__card-content"]}>
                <div>
                  {item.objectName ? (
                    <span className={styles.list__item}>
                      <strong className={styles["list__item-bold"]}>
                        {item.objectName}
                      </strong>{" "}
                      {item.name}
                    </span>
                  ) : boldName ? (
                    <h2 className={styles.list__item}>{item.name}</h2>
                  ) : (
                    <span
                      className={`${styles.list__item} ${styles["list__item-normal"]}`}
                    >
                      {item.name}
                    </span>
                  )}

                  {item.address && (
                    <p className={styles["list__item-address"]}>
                      {item.address}
                    </p>
                  )}
                </div>

                {monitorStatus && (
                  <span
                    className={styles["list__status-circle"]}
                    style={{ backgroundColor: monitorStatus.color }}
                    title={item.digitalMonitorStatusText}
                  />
                )}
              </div>
            </div>
          );
        })}
      </ul>
    </div>
  );
};
